export const APP_THEME_COLORS = {
  10: '#f8f7f7',
  20: '#e26e09',
  30: '#004165',
  40: '#d6e0e6',
  50: '#4caf50',
}
